import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AccountClientDetailsService } from '../../../service/account-client-edit/account-client-details.service';

export interface OrderViewModal {
  accountClientID: string;
  empresaID: string;
  tipoRemessa: string;
}

@Component({
  selector: 'app-order-view-modal',
  templateUrl: './order-view-modal.component.html',
  styleUrls: ['./order-view-modal.component.scss'],
  providers: [AccountClientDetailsService]
})

export class OrderViewModalComponent extends DialogComponent<OrderViewModal, any> implements OrderViewModal {

  accountClientID: string;
  
  empresaID: string;

  tipoRemessa: string;

  public titulo: string;
  
  public orders: any[] = [];

  public loadDeliveries: boolean = false;

  constructor(dialogService: DialogService, private accountClientDetailsService: AccountClientDetailsService) {
    super(dialogService);
  }
  ngOnInit() {
    console.log("accountClientID", this.accountClientID);
    console.log("empresaID", this.empresaID);

    switch(this.tipoRemessa) {
      case 'R': this.titulo = 'Remessas (R$)'; break;
      case 'V': this.titulo = 'Rem. Vd. Ordem (R$)'; break;
      case 'E': this.titulo = 'Rem. Exportação (R$)'; break;
    }

    this.getClientDeliveries();
  }

  getClientDeliveries() {
    this.accountClientDetailsService.getClientDeliveries(this.accountClientID, this.empresaID, this.tipoRemessa).subscribe(result => {
			if (result.Success) {
        this.loadDeliveries = true;
        this.orders = result.Result;
			}
		}, error => {
			console.log(error);
		});
  }

  confirm() {
		this.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/order-view-modal/order-view-modal.component.ts